// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1600":"b3ad760f","5850":"49a8727a"}[chunkId] || chunkId) + "." + {"1036":"598c256db0115319","1600":"73a34aa789ee800b","3255":"cbf3a39b2e9bd9e3","3564":"eb18b318a3737785","5850":"23128d64765cf954","7889":"5384eb610e46f70e"}[chunkId] + ".js";
};